import styled from "styled-components";

import { Button, FlexRow } from "@similarweb/ui-components";

export const ButtonsWrapper = styled(FlexRow)<{ isFirstButtonVisible: boolean }>`
    box-sizing: border-box;
    justify-content: ${({ isFirstButtonVisible }) => (isFirstButtonVisible ? "space-between" : "flex-end")};
    gap: 4px;
    padding: 8px 16px 16px;
`;

export const DeleteListButton = styled(Button)`
    margin-right: 4px;
`;
